import { useEffect, useState, type CSSProperties } from "react";

/**
 * QR image rendered through `qrcode.toDataURL` (contract §7: content = asset
 * tag). Kept as an <img> so it prints and copies like any picture. The
 * encoder is imported on demand so it stays out of the main chunk.
 */
export function QrCode({
  value, size = 160, alt, className, style,
}: {
  value: string;
  /** Pixel width; also the render width of the data URL. */
  size?: number;
  alt?: string;
  className?: string;
  style?: CSSProperties;
}) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setSrc(null);
    import("qrcode")
      .then((QRCode) => QRCode.toDataURL(value, { width: size, margin: 1, errorCorrectionLevel: "M" }))
      .then((url) => { if (!cancelled) setSrc(url); })
      .catch(() => { if (!cancelled) setSrc(null); });
    return () => { cancelled = true; };
  }, [value, size]);

  return (
    <span className={`qr-box${className ? ` ${className}` : ""}`} style={{ width: size, height: size, ...style }} aria-busy={src === null}>
      {src && <img src={src} width={size} height={size} alt={alt ?? value} />}
    </span>
  );
}
